module.exports = __webpack_public_path__ + "static/promo-preview-0e8d29b51afe2f13daf9b5a295133c00.gif";